import { type CSSProperties } from 'react';

export type WeatherIconCategory = 'clear' | 'partly-cloudy' | 'cloudy' | 'fog' | 'drizzle' | 'rain' | 'snow' | 'showers' | 'thunderstorm' | 'mixed';

type WeatherIconProps = {
  category: WeatherIconCategory;
  label?: string;
  size?: number;
  style?: CSSProperties;
};

const cloud = <path d="M7.3 18h10.2a3.5 3.5 0 0 0 .3-7 5.7 5.7 0 0 0-10.9 1.2A2.9 2.9 0 0 0 7.3 18Z" />;

export function WeatherIcon({ category, label, size = 20, style }: WeatherIconProps) {
  const precipitation = category === 'drizzle' || category === 'rain' || category === 'showers';
  return (
    <svg
      aria-hidden={label ? undefined : 'true'}
      aria-label={label}
      fill="none"
      height={size}
      role={label ? 'img' : undefined}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      style={{ display: 'inline-block', flexShrink: 0, verticalAlign: '-0.22em', ...style }}
      viewBox="0 0 24 24"
      width={size}
    >
      {category === 'clear' ? <><circle cx="12" cy="12" r="3.5" /><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" /></> : null}
      {category === 'partly-cloudy' || category === 'mixed' ? <><circle cx="8" cy="8" r="3" /><path d="M8 2.5V1M2.5 8H1M4.1 4.1 3 3M11.9 4.1 13 3" />{cloud}</> : null}
      {category === 'cloudy' ? cloud : null}
      {category === 'fog' ? <><path d="M4 8h12M2 12h18M5 16h14" /></> : null}
      {precipitation ? <>{cloud}<path d={category === 'drizzle' ? 'M9 20v.1M14 20v.1' : 'm9 20 1-2m4 2 1-2'} /></> : null}
      {category === 'snow' ? <>{cloud}<path d="M9 20h.01M14 20h.01M11.5 22h.01" /></> : null}
      {category === 'thunderstorm' ? <>{cloud}<path d="m13 17-2 3h2l-1 2" /></> : null}
    </svg>
  );
}
